if (!window.DeferredMedia) {
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener("click", this.loadContent.bind(this));
    }

    loadContent(focus = true) {
      this.pauseAllMedia(this.closest('media-gallery'));
      if (!this.getAttribute("loaded")) {
        const content = document.createElement("div");
        content.appendChild(
          this.querySelector("template").content.firstElementChild.cloneNode(
            true
          )
        );

        this.setAttribute("loaded", true);
        const deferredElement = this.appendChild(
          content.querySelector("video, model-viewer, iframe")
        );
        if (focus) deferredElement.focus();
        if (
          deferredElement.nodeName == "VIDEO" &&
          deferredElement.getAttribute("autoplay")
        ) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }

    pauseAllMedia(element) {
      element.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      });
      element.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      element.querySelectorAll('video').forEach((video) => video.pause());
      element.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }
  }
  window.DeferredMedia = DeferredMedia;
}

if (!customElements.get("product-model")) {
  customElements.define(
    "product-model",
    class ProductModel extends DeferredMedia {
      constructor() {
        super();
      }

      loadContent() {
        super.loadContent();

        Shopify.loadFeatures([
          {
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }

      setupModelViewerUI(errors) {
        if (errors) return;

        this.modelViewerUI = new Shopify.ModelViewerUI(
          this.querySelector("model-viewer")
        );

        // MOVTECH: saját kiegészítés a gyári Purity-kódhoz — a modellbe épített
        // működés-animáció lejátszása és megállítása (animáció gomb).
        this.setupMotionToggle();
      }

      // MOVTECH: a [media-model] wrapperben lévő .model-motion-toggle gombot köti
      // a model-viewer animációjához. Ha nincs gomb vagy a modell nem tartalmaz
      // animációt, nem csinál semmit — a gomb rejtve marad.
      setupMotionToggle() {
        const viewer = this.querySelector("model-viewer");
        const wrapper = this.closest("[media-model]");
        if (!viewer || !wrapper) return;

        const button = wrapper.querySelector(".model-motion-toggle");
        if (!button) return;

        const setPlaying = (on) => {
          if (on) viewer.play({ repetitions: Infinity });
          else viewer.pause();
          button.classList.toggle("is-playing", on);
          button.setAttribute("aria-pressed", String(on));
          const label = on ? button.dataset.labelPause : button.dataset.labelPlay;
          button.setAttribute("aria-label", label);
          button.setAttribute("title", label);
        };

        const start = () => {
          const animations = viewer.availableAnimations || [];
          if (animations.length === 0) return;
          wrapper.setAttribute("data-model-loaded", "");

          if (!button.dataset.motionBound) {
            button.dataset.motionBound = "1";
            button.addEventListener("click", (event) => {
              event.preventDefault();
              event.stopPropagation();
              // mindig a modell valós állapotából indulunk ki: a galéria
              // lapozása is megállíthatja az animációt a hátunk mögött
              setPlaying(viewer.paused);
            });
          }

          // Csökkentett mozgást kérő látogatónál ne induljon el magától.
          const reduced = window.matchMedia(
            "(prefers-reduced-motion: reduce)"
          ).matches;
          setPlaying(!reduced);
        };

        if (viewer.loaded) start();
        else viewer.addEventListener("load", start, { once: true });
      }
    }
  );
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", () =>
        this.setupShopifyXR()
      );
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener("DOMContentLoaded", () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
